import React from 'react';
import { useRecordContext } from 'react-admin';
import { Avatar, useTheme } from '@mui/material';

import BusinessIcon from '@mui/icons-material/Business';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import PersonIcon from '@mui/icons-material/Person';
import ExtensionIcon from '@mui/icons-material/Extension';

import entityTypes, { EntityTypes } from '../constants/entityTypes';

const EntityTypeIcon = ({ entityType }: { entityType: EntityTypes }) => {
  switch (entityType) {
    case entityTypes.INDIVIDUAL:
      return <PersonIcon />;
    case entityTypes.BUSINESS:
      return <BusinessIcon />;
    case entityTypes.CAR:
      return <DriveEtaIcon />;
    case entityTypes.ACCOUNT:
      return <AccountBalanceIcon />;
    case entityTypes.PRODUCT:
      return <ExtensionIcon />;
    case entityTypes.UNKNOWN:
      return <PersonIcon />;
    default:
      entityType satisfies never;
      return null;
  }
};

const EntityTypeAvatarField = () => {
  const theme = useTheme();
  const record = useRecordContext<{
    type: EntityTypes;
  }>();
  if (!record) return null;

  return (
    <Avatar sx={{ backgroundColor: theme.palette.primary.main }}>
      <EntityTypeIcon entityType={record.type} />
    </Avatar>
  );
};

export default EntityTypeAvatarField;
